import Vue from 'vue'
import routes from './map'
import Router from 'vue-router'
Vue.use(Router)

let router
const routeList = Object.keys(routes).reduce((previous, current) => {
  return (previous.push({ path: current, ...routes[current] }), previous)
}, [])

router = new Router({
  // mode: 'history',
  base: process.env.ROUTER_ROOT,
  routes: routeList,
  scrollBehavior (to, from, savedPosition) {
    return savedPosition || { x: 0, y: 0 }
  }
})

router.beforeEach((to, from, next) => {
  if (to && to.name) {
    const n = to.name.indexOf('pay') !== -1 || to.name.indexOf('version') !== -1
    const log = window.localStorage.getItem('wuweiLogIn') === 'false'
    if (n && log) {
      // next({ path: '/' })
      next()
    } else {
      const lang = localStorage.getItem('lang') || 'zh-CN'
      to.matched.filter(({ meta }) => meta && meta.i18n && meta.i18n[lang] && meta.i18n[lang].title).map(({ meta }) => {
        const { title } = meta.i18n[lang]
        Vue.setTitle(title)
      })
      next()
    }
  } else {
    next()
  }
})

/**
 * @description 页面离开全局监听
 */
router.afterEach((to, from) => {
  Vue.nextTick(() => {
  })
})

Vue.router = router

export default router
